<template>
  <section class="ON_main_article_area ON_single_post_column ON_100px_padding">
    <div class="container">
      <div class="row">
        <div class="col-lg-8">
          <div class="ON_about_area ON_60px_padding ON_grey_bg">
            <div class="container">
              <div class="row">
                <div class="col-md-7 col-sm-6">
                  <div class="about-title clearfix">
                    <h1>About <span>Us</span></h1>
                    <h3>Objective News</h3>
                    <p class="about-paddingB">
                      We are the source of non biased, objective news analysis.
                      We are collecting all the most important news of today,
                      and analyzing each article with state of the art machine
                      learning algorithms. Using that approach, we provide only
                      the most relevant and important news of today, presented
                      without bias, without amplifying or silencing any source.
                      We will provide you with impartial information, and it is
                      up to you, dear reader, to form your own opinion.
                    </p>
                    <p>
                      We are a team of passionate software engineers who beleive
                      in truth and fact. If bias and subjectivity is either
                      exposed or removed, all that's left is the truth.
                    </p>
                    <div class="about-icons">
                      <ul>
                        <li>
                          <a
                            href="https://www.facebook.com/Objective-News-102027294866444/"
                            target="_blank"
                            ><i
                              id="social-fb"
                              class="fa fa-facebook fa-3x social"
                            ></i
                          ></a>
                        </li>
                        <li>
                          <a
                            href="https://twitter.com/ONews_Official"
                            target="_blank"
                            ><i
                              id="social-tw"
                              class="fa fa-twitter fa-3x social"
                            ></i
                          ></a>
                        </li>
                        <li>
                          <a
                            href="https://www.instagram.com/objectivenews_official/"
                            target="_blank"
                            ><i
                              id="social-gp"
                              class="fa fa-instagram fa-3x social"
                            ></i
                          ></a>
                        </li>
                        <li>
                          <a href="mailto:contactus@objective-news.com"
                            ><i
                              id="social-em"
                              class="fa fa-envelope fa-3x social"
                            ></i
                          ></a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-md-5 col-sm-6">
                  <div class="img-fluid">
                    <img
                      src="../assets/slice.png"
                      alt=""
                      width="593"
                      height="400"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  created() {
    document.title = "ON About Us";
  }
};
</script>

<style scoped>
.ON_60px_padding {
  padding: 60px 0px 60px 0px;
}
.ON_grey_bg {
  background: #f1f1f1 !important;
}
.about-title {
}
.about-title h1 {
  color: #535353;
  font-size: 45px;
  font-weight: 600;
}
.about-title span {
  color: #af0808;
  font-size: 45px;
  font-weight: 700;
}
.about-title h3 {
  color: #535353;
  font-size: 23px;
  margin-bottom: 24px;
}
.about-title p {
  color: #7a7a7a;
  line-height: 1.8;
  margin: 0 0 15px;
}
.about-paddingB {
  padding-bottom: 12px;
}
.about-img {
  padding-left: 57px;
}

/* Social Icons */
.about-icons {
  margin: 48px 0px 48px 0px;
}
.about-icons i {
  margin-right: 10px;
  padding: 0px;
  font-size: 35px;
  color: #323232;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
}
.about-icons li {
  margin: 0px;
  padding: 0;
  display: inline-block;
}
#social-fb:hover {
  color: #3b5998;
  transition: all 0.001s;
}
#social-tw:hover {
  color: #4099ff;
  transition: all 0.001s;
}
#social-gp:hover {
  color: #d34836;
  transition: all 0.001s;
}
#social-em:hover {
  color: #f39c12;
  transition: all 0.001s;
}
</style>
